import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import Logo from "./Logo";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo & About */}
        <div className="footer-col">
          <div className="footer-logo">
            <Logo type="default" link="/home" />
          </div>
          <p>
            Recla delivers smart printing solutions, reducing costs up to 20%, 
            with premium products and 24/7 support.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/home">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Products & Services</Link></li>
            {/* <li><Link to="/blog">Blog</Link></li> */}
          </ul>
        </div>

        {/* Support Links */}
        <div className="footer-col">
          <h3>Support Links</h3>
          <ul>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/return-policy">Return Policy</Link></li>
            <li><Link to="/terms-and-conditions">Terms & Conditions</Link></li>
          </ul>
        </div>

        

        {/* Contact Info */}
        <div className="footer-col">
          <h3>Contact Us</h3>
          <p>
            Address: NO. 77, GRA UMUEBEKE STREET, ABA,
            ABIA STATE, NIGERIA <br />
            Email: reclacac@gmail.com <br />
            Email: support@recla.in <br />
            Phone: 08169405098<br />
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>
          Copyright © 2025 Recla | Created & Designed by{" "}
          <a
            href="https://strivik.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Strivik Business Solutions Private Limited
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
